export default class EditorUtils
{
    static activeEditor() {
        return tinymce.activeEditor
    }

    static execCommand(command, user_interface = false, value = null) {
        this.activeEditor().execCommand(command, user_interface, value)
    }

    static getCurrentPositionNode() {
        return this.activeEditor().selection.getNode()
    }

    static nodeIsVariable(node = null) {
        node = node === null ? this.getCurrentPositionNode() : node

        return $(node).hasClass('blade-variable')
    }

    static insertVariable(variableMarkup) {
        this.execCommand('mceInsertContent', false, variableMarkup)
    }

    static insertFunction(func) {
        this.execCommand('mceInsertContent', false, func)
        let editor = this.activeEditor()

        let cursorNode = editor.dom.select('.__cursor')[0]
        editor.selection.select(cursorNode); //select the inserted element
        editor.selection.collapse(0); //collapses the selection to the end of the range, so the cursor is after the inserted element
        editor.dom.remove(cursorNode); //remove the element
    }
}